import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { ApiKeysTable } from 'components/profile/ApiKeysTable'
import { ProfileIndexRoutesWrapper as RoutesWrapper } from 'components/profile/ProfileIndexRoutesWrapper'
import { ProfilePage } from 'components/profile/ProfilePage'
import UserDetails from 'components/profile/UserDetails'
import UserIntegrations from 'components/profile/UserIntegrations'
import { UserSecurity } from 'components/profile/UserSecurity'
import { useSettingsQueryContext } from 'components/rbac-settings/SettingsQueryContext'
import { TrackedGremlinRouteElement } from 'components/TrackedGremlinRouteElement'
import { isPrivateEdition } from 'utils/app-config'

const ProfileIndex: React.FC = () => {
  const { company } = useSettingsQueryContext()
  const { api_keys_enabled: areApiKeysEnabled } =
    company?.auth_method_prefs ?? {}

  return (
    <Routes>
      <Route element={<RoutesWrapper />}>
        <Route element={<ProfilePage />}>
          <Route index element={<Navigate to="details" />} path="*" />
          <Route
            index
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<UserDetails />}
                name="Details"
              />
            }
            path="details"
          />
          <Route
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<UserSecurity />}
                name="Security"
              />
            }
            path="security"
          />
          {!isPrivateEdition() && (
            <Route
              element={
                <TrackedGremlinRouteElement
                  loggedIn
                  component={<UserIntegrations />}
                  name="Integrations"
                />
              }
              path="integrations"
            />
          )}
          {areApiKeysEnabled && (
            <Route
              element={
                <TrackedGremlinRouteElement
                  loggedIn
                  component={<ApiKeysTable apiKeysLimit={5} />}
                  name="API Keys"
                />
              }
              path="apikeys"
            />
          )}
        </Route>
      </Route>
    </Routes>
  )
}

// this needs to be a default export because it is a chunk loaded by webpack
export default ProfileIndex
